import React, { ReactElement } from 'react';
import { Modal, ModalBody, Button, Text, Box, Heading } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import fileExecutionSuccess from 'assets/bulkUploads/file-execution-success.svg';

export const ExecutionSuccessfullModal = ({
  isOpen,
  mainText,
  subText,
  callBackOnClick,
  buttonText,
}: {
  isOpen: boolean;
  mainText: string;
  subText?: string;
  callBackOnClick: Function;
  buttonText?: string;
}): ReactElement => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={() => {
        //
      }}>
      <ModalBody padding="spacing.0">
        <img alt="" height="auto" width="100%" src={getStaticMediaUrl(fileExecutionSuccess)} />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding={['spacing.2', 'spacing.7', 'spacing.7', 'spacing.7']}>
          <Heading textAlign="center" size="small" weight="semibold" marginBottom="spacing.2">
            {mainText}
          </Heading>
          <Text textAlign="center" weight="regular" color="surface.text.gray.muted">
            {subText}
          </Text>
          <Button
            marginTop="spacing.8"
            onClick={() => {
              callBackOnClick();
            }}>
            {buttonText ?? 'Go to Dashboard'}
          </Button>
        </Box>
      </ModalBody>
    </Modal>
  );
};
